<mat-dialog-content class="modal-header"
  ><h2 mat-dialog-title>RESTABLECER ACCESSOS</h2></mat-dialog-content
>
<mat-dialog-content class="modal-body">
  <div class="block-content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-3 control-label">Comentarios:</label>
        <div class="col-md-9">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Ingresa los comentarios</mat-label>
            <textarea matInput placeholder="Comentarios" [(ngModel)]="model.comentarios" rows="5" name="comentarios" [maxlength]="2000" cdkFocusInitial></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button class="btn btn-naranja" mat-button [mat-dialog-close]="model" (click)="Save()" [disabled]="esValido()"><mat-icon>save</mat-icon> Guardar</button>
  <button class="btn btn-naranja2" mat-button (click)="onNoClick()"><mat-icon>exit_to_app</mat-icon> Cancelar</button>
</mat-dialog-actions>

<!-- <pre>{{ fechaInduccion | json }}</pre>
<pre>{{ model.fechaHoraInduccion | date: "HH:mm" }}</pre> -->
<!-- <pre>{{ model | json }}</pre> -->

